<template>
  <div class="pg-promo">
    <div class="c">
        <div class="content"></div>
        <p class="title">PG 电游热门游戏，深受各位新老客户喜爱，现我司独家推出针对PG游戏大礼包，集合各种投注有奖返利活动，欢迎新老玩家入驻。</p>
        <div class="option">
            <ul>
                <li :class="{'on': currentIndex == 0}" @click="currentIndex = 0">全部</li>
                <li :class="{'on': currentIndex == 1}" @click="currentIndex = 1" v-show="false">注单</li>
                <li :class="{'on': currentIndex == 2}" @click="currentIndex = 2" v-show="false">救援金</li>
            </ul>
            <div @click="$parent.promoShow=true;">领取记录</div>
        </div>
        <div class="record">
            <ul>
                <li v-if="rescueUi" style="background:#008CFF66;" v-show="currentIndex==0||currentIndex==2&&rescueUi.promoType==1">
                    <div class="top">
                        <p>{{rescueUi.title}}</p>
                        <span @click="$parent.promo1Show=0">活动详情</span>
                    </div>
                    <div class="info">
                        <div>
                            <p>{{rescueUi.subTitle}}</p>
                            <p>{{rescueUi.startTime}}</p>
                        </div>
                        <span>{{rescueUi.reward}}</span>
                    </div>
                    <div class="desc">
                        <p><span>统计时间</span><span>{{rescueUi.reportTime}}</span></p>
                        <p><span>净输赢</span><span>{{rescueUi.totalWinlost}}</span></p>
                        <p v-if="false"><span>输赢&nbsp;&nbsp;<span>{{rescueUi.totalWinlost}}</span></span><span style="color:#FFFFFFB2">优惠&nbsp;&nbsp;<span>{{rescueUi.promo}}</span></span><span style="color:#FFFFFFB2">返水&nbsp;&nbsp;<span>{{rescueUi.turnover}}</span></span></p>
                    </div>
                    <div class="btn" @click="applicationPGPromoAsync(rescueUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{rescueUi.buttonStatus==0?'':'已'}}{{rescueUi.submitType==0?'领取':'申请'}}</div>
                </li>
                <li v-if="orderUi" style="background:#FFAB0F66;" v-show="currentIndex==0||currentIndex==1&&orderUi.promoType==0">
                    <div class="top">
                        <p>{{orderUi.title}}</p>
                        <span @click="$parent.promo1Show=1">活动详情</span>
                    </div>
                    <div class="info">
                        <div>
                            <p>{{orderUi.subTitle}}</p>
                            <p>{{orderUi.startTime}}</p>
                        </div>
                        <span>{{orderUi.reward}}</span>
                    </div>
                    <div class="desc">
                        <p><span>统计时间</span><span>{{orderUi.reportTime}}</span></p>
                         <p><span>注单数量</span><span>{{orderUi.orderCount}}</span></p>
                         <p v-if="false"><span>流水&nbsp;&nbsp;<span>{{orderUi.totalBetAmount}}</span></span><span style="color:#FFFFFFB2">注单数量&nbsp;&nbsp;<span>{{orderUi.orderCount}}</span></span></p>
                    </div>
                    <div class="btn" @click="applicationPGPromoAsync(orderUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{orderUi.buttonStatus==0?'':'已'}}{{orderUi.submitType==0?'领取':'申请'}}</div>
                </li>
                <li v-if="betUi" style="background:#FF585866;" v-show="currentIndex==0||currentIndex==1&&betUi.promoType==0">
                    <div class="top">
                        <p>{{betUi.title}}</p>
                        <span @click="$parent.promo1Show=2">活动详情</span>
                    </div>
                    <div class="info">
                        <div>
                            <p>{{betUi.subTitle}}</p>
                            <p>{{betUi.startTime}}</p>
                        </div>
                        <span>{{betUi.reward}}</span>
                    </div>
                    <div class="desc">
                        <p><span>统计时间</span><span>{{betUi.reportTime}}</span></p>
                        <p><span>流水总额</span><span>{{betUi.totalBetAmount}}</span></p>
                    </div>
                    <div class="btn" @click="applicationPGPromoAsync(betUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{betUi.buttonStatus==0?'':'已'}}{{betUi.submitType==0?'领取':'申请'}}</div>
                </li>
                <li v-if="luckyOrderUi" style="background:#FFF64A66;" v-show="currentIndex==0||currentIndex==1&&luckyOrderUi.promoType==0">
                    <div class="top">
                        <p>{{luckyOrderUi.title}}</p>
                        <span @click="$parent.promo1Show=3">活动详情</span>
                    </div>
                    <div class="info">
                        <div>
                            <p>{{luckyOrderUi.subTitle}}</p>
                            <p>{{luckyOrderUi.startTime}}</p>
                        </div>
                        <span>{{luckyOrderUi.reward}}</span>
                    </div>
                    <div class="desc">
                        <p><span>统计时间</span><span>{{luckyOrderUi.reportTime}}</span></p>
                        <p><span>注单编号</span><span>{{luckyOrderUi.orderNo}}</span></p>
                    </div>
                    <div class="btn" @click="applicationPGPromoAsync(luckyOrderUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{luckyOrderUi.buttonStatus==0?'':'已'}}{{luckyOrderUi.submitType==0?'领取':'申请'}}</div>
                </li>
                <li v-if="highOddsOrdersUi" style="background:#60FF6566;" v-show="currentIndex==0||currentIndex==1&&highOddsOrdersUi.promoType==0">
                    <div class="top">
                        <p>{{highOddsOrdersUi.title}}</p>
                        <span @click="$parent.promo1Show=5">活动详情</span>
                    </div>
                    <div class="info">
                        <div>
                            <p>{{highOddsOrdersUi.subTitle}}</p>
                            <p>{{highOddsOrdersUi.startTime}}</p>
                        </div>
                        <span>{{highOddsOrdersUi.reward}}</span>
                    </div>
                    <div class="desc">
                        <p><span>统计时间</span><span>{{highOddsOrdersUi.reportTime}}</span></p>
                        <p><span>注单编号&nbsp;&nbsp;<span>{{highOddsOrdersUi.orderNo}}</span></span><span style="color:#FFFFFFB2">倍数&nbsp;&nbsp;<span>{{highOddsOrdersUi.rewardTimes}}</span></span></p>
                    </div>
                    <div class="btn" @click="applicationPGPromoAsync(highOddsOrdersUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{highOddsOrdersUi.buttonStatus==0?'':'已'}}{{highOddsOrdersUi.submitType==0?'领取':'申请'}}</div>
                </li>
                <li v-if="taskLevelUi" style="background:#C164FF66;" v-show="currentIndex==0||currentIndex==1&&taskLevelUi.promoType==0">
                    <div class="top">
                        <p>{{taskLevelUi.title}}</p>
                        <span @click="$parent.promo1Show=4">活动详情</span>
                    </div>
                    <div class="info">
                        <div>
                            <p>{{taskLevelUi.subTitle}}</p>
                            <p>{{taskLevelUi.startTime}}</p>
                        </div>
                        <span>{{taskLevelUi.reward}}</span>
                    </div>
                    <div class="desc">
                        <p><span>累计流水</span><span>{{taskLevelUi.totalBetAmount}}</span></p>
                        <p><span>关卡</span><span>{{taskLevelUi.taskLevel}}</span></p>
                    </div>
                    <div class="btn" @click="applicationPGPromoAsync(taskLevelUi)" style="background:linear-gradient(180deg, #FFE19C 0%, #FFB200 100%)">{{taskLevelUi.buttonStatus==0?'':'已'}}{{taskLevelUi.submitType==0?'领取':'申请'}}</div>
                </li>
            </ul>
        </div>
        <div class="rules">
            <p></p>
            <div>
                1.优惠时间以每日0:00:00-23:59:59为单位，系统会统计会员在每个单位时间的PG和电游平台投注数据，包括注单数据，投注数据等。此数据实时更新，具体请查看注单详情，关于优惠奖金政策请查看具体优惠详情。  <br/>  
                2.部分优惠是系统派发，部分优惠需要审核后派发，具体以单个优惠详情为主。  <br/>  
                3.特定优惠仅针对特定游戏平台，非指定平台不能参加此类单项优惠，具体优惠资格以详情为准，或者咨询客服了解更多优惠资讯.
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import {
    queryPGDailyRescuePromoUI,
    queryPGDailyOrderPromoUI,
    queryPGDailyBetPromoUI,
    applicationPGPromo,
    queryPGLuckyOrderPromoUI_V,
    queryPGTaskLevelPromoUI_V,
    queryPGHighOddsOrdersPromoUI_V
} from '../api';

export default {
    name: 'PGPromo',
    data() {
        return {
            currentIndex: 0,
            rescueUi: null,
            orderUi: null,
            betUi: null,
            luckyOrderUi: null,
            taskLevelUi: null,
            highOddsOrdersUi: null
        };
    },
    computed: {
        tabShowRescue() {
            return this.currentIndex === 0 || this.currentIndex === 2;
        },
        tabShowOrder() {
            return this.currentIndex === 0 || this.currentIndex === 1;
        },
        tabShowBet() {
            return this.currentIndex === 0;
        }
    },
    created() {
        this.queryPGDailyRescuePromoUIAsync();
        this.queryPGDailyOrderPromoUIAsync();
        this.queryPGDailyBetPromoUIAsync();
        this.queryPGLuckyOrderPromoUI_VAsync();
        this.queryPGTaskLevelPromoUI_VAsync();
        this.queryPGHighOddsOrdersPromoUI_VAsync();
    },
    methods: {
        /** 从 UI 接口返回对象取 promoCode（兼容 camelCase / PascalCase） */
        pickPromoCode(ui) {
            if (!ui) return null;
            const v = ui.promoCode != null ? ui.promoCode : ui.PromoCode;
            return v != null && v !== '' ? Number(v) : null;
        },
        async applicationPGPromoAsync(ui) {
            const promoCode = this.pickPromoCode(ui);
            if (promoCode == null || Number.isNaN(promoCode)) {
                this.$toast.fail('优惠编号无效');
                return;
            }
            let result = await applicationPGPromo(promoCode);
            if (!result.Message) {
                this.$toast.success('操作成功');
                this.queryPGDailyRescuePromoUIAsync();
                this.queryPGDailyOrderPromoUIAsync();
                this.queryPGDailyBetPromoUIAsync();
            } else {
                this.$toast.fail(result.Message);
            }
        },
        async queryPGDailyRescuePromoUIAsync() {
            let result = await queryPGDailyRescuePromoUI();
            if (result.Result) {
                this.rescueUi = result.Result;
            }
        },
        async queryPGDailyOrderPromoUIAsync() {
            let result = await queryPGDailyOrderPromoUI();
            if (result.Result) {
                this.orderUi = result.Result;
            }
        },
        async queryPGDailyBetPromoUIAsync() {
            let result = await queryPGDailyBetPromoUI();
            if (result.Result) {
                this.betUi = result.Result;
            }
        },
        async queryPGLuckyOrderPromoUI_VAsync() {
            let result = await queryPGLuckyOrderPromoUI_V();
            if (result.Result) {
                this.luckyOrderUi = result.Result;
            } 
        },
        async queryPGTaskLevelPromoUI_VAsync() {
            let result = await queryPGTaskLevelPromoUI_V();
            if (result.Result) {
                this.taskLevelUi = result.Result;
            }
        },
        async queryPGHighOddsOrdersPromoUI_VAsync() {
            let result = await queryPGHighOddsOrdersPromoUI_V();
            if (result.Result) {
                this.highOddsOrdersUi = result.Result;
            }
        }
    }
};
</script>

<style scoped>
.pg-promo {
  width: 100%;
  height: 100%;
  background: url('~@/img/PCBG.png') no-repeat #000E2C;
  background-size: contain;
  padding-top:5rem;
}

.c{
width:12rem;
margin: 0 auto;
}

.content {
  width: 100%;
  height: 0.32rem;
  background: url('~@/img/p_content.png') no-repeat center center;
}

p.title{
width: 100%;
text-align: center;
margin-top: 0.12rem;
}

.option{
width: 100%;
display: flex;
align-items: center;
justify-content: space-between;
margin-top: 0.24rem;
}

.option ul{
display: flex;
align-items: center;
justify-content: space-between;
/*width: 4.28rem;*/
height:0.58rem;
background: #030358;
border-radius: 0.2rem;
}

.option ul li{
width:1.4rem;
height:0.5rem;
line-height:0.5rem;
text-align: center;
cursor: pointer;
font-size: 0.2rem;
color: #FFFFFFCC;
font-weight: bolder;
}

.option ul li.on{
background: linear-gradient(-144.66deg, #28A9FF 0%, #0062FF 100%);
border-radius: 0.16rem;
}

.option div{
width:1.44rem;
height:0.6rem;
background: #030358;
border-radius: 0.08rem;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
font-size: 0.2rem;
font-weight: bolder;
color: #fff;
}

.option div::before{
content: '';
display: block;
width: 0.24rem;
height: 0.24rem;
background: url('~@/img/reco.png') no-repeat center center;
background-size: contain;
margin-right: 0.08rem;
}
.record {
margin: 0.24rem 0;
}

.record ul{
display: flex;
gap: 0.24rem;
flex-wrap: wrap;
}
.record ul li{
width: 3.84rem;
height: 2.27rem;
background: #60FF6566;
border-radius: 0.16rem;
}

.record ul li .top{
display: flex;
align-items: center;
justify-content: space-between;
}

.record ul li .top p{
min-width:0.82rem;
height:0.4rem;
line-height: 0.4rem;
text-align: center;
font-weight: bold;

border-radius: 0.16rem 0px 0.16rem 0px;
background: #FF00008C;
padding:0 0.08rem;
}

.record ul li .top span{
width:0.83rem;
height:0.24rem;
line-height: 0.24rem;
text-align: center;
font-size: 0.12rem;
font-weight: bold;
color: #fff;
background: #008CFF8C;
border-radius: 0.12rem;
cursor: pointer;
background: #00000033;
margin-right: 0.08rem;;
display: flex;
align-items: center;
justify-content: center;
}

.record ul li .top span::after{
content: '';
display: block;
width: 0.16rem;
height: 0.16rem;
background: url('~@/img/info1.png') no-repeat center center;
background-size: contain;
margin-left: 0.04rem;
}

.record ul li .info{
display: flex;
justify-content: space-between;
align-items: center;
border-bottom: 1px solid #FFFFFF19;
padding: 0 0.08rem;
}

.record ul li .info div p:first-child{
font-size: 0.18rem;
font-weight: bolder;
line-height: 0.3rem;
}

.record ul li .info div p:last-child{
font-size: 0.14rem;
font-weight: bolder;
color:#FAE42C;
}

.record ul li .info span{
font-size: 0.48rem;
font-weight: bold;
color:#FAE42C;
}
.record ul li .desc{
margin-top: 0.08rem;
padding: 0 0.08rem;
}
.record ul li .desc p{
display: flex;
justify-content: space-between;
align-items: center;
font-size: 0.14rem;

margin-bottom: 0.08rem;
} 
.record ul li .desc p span:first-child{
color:#FFFFFFB2;
}
.record ul li .desc p span:last-child{
color:#FFF;
}

.record ul li .btn{
width: 3.68rem;
height: 0.48rem;
line-height: 0.48rem;
text-align: center;
font-size: 0.2rem;
font-weight: bolder;
color: #B6471B;
background: linear-gradient(180deg, #FFE19C 0%, #FFB200 100%);
border-radius: 0.12rem;
cursor: pointer;
margin: 0 auto;
margin-top: 0.16rem;
}

.rules{
margin: 0.24rem 0;
}

.rules p{
  width: 100%;
  height: 0.32rem;
  background: url('~@/img/p_rules.png') no-repeat center center;
}

.rules div{
font-size: 0.14rem;
color: #FFFFFFE5;
margin-top: 0.16rem;
line-height: 0.24rem;;
}
</style>